module.exports = __webpack_public_path__ + "628cb2251e9ce2a1a47373650eef5de7.ogg";


//////////////////
// WEBPACK FOOTER
// ./src/Rist/content/tourWorks/room8/audio2/08_2MCA-Cape-Cod-Chandelier.ogg
// module id = 791
// module chunks = 0